var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filters__dropdown-wrapper" }, [
    _c(
      "label",
      { staticClass: "utility-flex", attrs: { for: "multiselect" } },
      [_vm._v("Districts:")]
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("multiselect", {
          attrs: {
            label: "Name",
            placeholder: "All districts",
            disabled: _vm.disableSubRegionDropdown,
            "hide-selected": true,
            multiple: true,
            options: _vm.subRegionsForRegion,
            searchable: false,
            showLabels: false,
            tabIndex: 0,
            value: _vm.selectedSubregions,
          },
          on: { input: _vm.selectSubRegions, keypress: _vm.selectSubRegions },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "region__tag-wrapper" },
          _vm._l(_vm.$store.state.selectedSubRegions, function (subRegion) {
            return _c(
              "div",
              {
                key: subRegion.ID,
                staticClass: "region__tag",
                class: { "is-tab2": _vm.isTab2 },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "region__tag-content",
                    attrs: {
                      tabindex: "0",
                      name: "subregion.Name",
                      "data-id": subRegion.ID,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.removeSubRegions(
                          subRegion.ID,
                          subRegion.Name
                        )
                      },
                      keypress: function ($event) {
                        return _vm.removeSubRegions(
                          subRegion.ID,
                          subRegion.Name
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(subRegion.Name) + "\n          "
                    ),
                    _c("span", { staticClass: "icon icon-close-circle-right" }),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }